import { useEffect, useState } from 'react';

/**
 * Devuelve `true` sólo cuando `active` se mantuvo `true` durante `delayMs`
 * seguidos; vuelve a `false` apenas `active` se apaga.
 *
 * Sirve para no PARPADEAR un loader en cargas sub-100ms: mostramos el loader
 * únicamente si la carga realmente tardó. Si los datos llegan antes del umbral,
 * el loader nunca aparece y el contenido entra directo (con su fade de reveal).
 */
export function useDeferredFlag(active: boolean, delayMs: number): boolean {
  const [on, setOn] = useState(false);

  useEffect(() => {
    if (!active) {
      setOn(false);
      return;
    }
    const t = setTimeout(() => setOn(true), delayMs);
    return () => clearTimeout(t);
  }, [active, delayMs]);

  return on;
}
